import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

const DELAY = 5000;
const SPEED = 600;

const setupCarousel = (el) => {
  const slides = el.querySelectorAll('.swiper-slide');
  if (slides.length <= 1) return null;

  const paginationEl = el.querySelector('.image-pagination');
  if (!paginationEl) return null;

  const swiper = new Swiper(el, {
    modules: [Autoplay],
    loop: true,
    speed: SPEED,
    autoplay: {
      delay: DELAY,
      disableOnInteraction: false,
    },
  });

  const slideCount = Array.from(swiper.slides).filter(
    s => !s.classList.contains('swiper-slide-duplicate')
  ).length;
  const bullets = [];
  let prevIndex = swiper.realIndex;

  for (let i = 0; i < slideCount; i++) {
    const bullet = document.createElement('span');
    bullet.classList.add('image-bullet');
    bullet.addEventListener('click', () => {
      swiper.slideToLoop(i);
    });
    paginationEl.appendChild(bullet);
    bullets.push(bullet);
  }

  swiper.on('autoplayStart', () => {
    const progress = 1 - (swiper.autoplay.timeLeft / DELAY);
    bullets[swiper.realIndex]?.style.setProperty('--progress', `${progress}`);
  });

  swiper.on('autoplayTimeLeft', (_, _time, progress) => {
    const realIndex = swiper.realIndex;

    if (realIndex !== prevIndex) {
      bullets[prevIndex]?.style.setProperty('--progress', '0');
      prevIndex = realIndex;
    }

    bullets[realIndex]?.style.setProperty('--progress', `${1 - progress}`);
  });

  const onVisibilityChange = () => {
    if (!document.hidden) {
      swiper.autoplay?.start();
    }
  };
  document.addEventListener('visibilitychange', onVisibilityChange);

  return () => {
    document.removeEventListener('visibilitychange', onVisibilityChange);
    swiper.destroy(true, true);
  };
};

export const initImageCarousel = () => {
  const elements = document.querySelectorAll('.image-carousel');
  const cleanups = [];
  elements.forEach(el => {
    const cleanup = setupCarousel(el);
    if (cleanup) cleanups.push(cleanup);
  });
  if (cleanups.length === 0) return;
  return () => cleanups.forEach(fn => fn());
};
